export const isExponentialRampToValueAutomationEvent = (automationEvent) => {
    return automationEvent.type === 'exponentialRampToValue';
};
//# sourceMappingURL=exponential-ramp-to-value-automation-event.js.map